<ng-container *transloco="let translate">
	<ng-container *clientScreen="let isDesktop = isDesktop">
		@if (
			{
				username: username$ | async,
			};
			as vm
		) {
			<base-modal #baseModal [fullSize]="true" [showClose]="true" (closed)="_onModalClosed()">
				<div class="w-100 h-100 talign-c fl fl-dir-c fl-ai-fs fl-jc-fs">
					<div class="fl-fixed w-100 fw-bold fs-l p-2-b fc-400">
						{{ translate('home.getting_started.congratulations') }}
					</div>
					<div
						class="fl-fixed w-100 fw-bold p-2-b"
						[style.fontSize]="isDesktop ? 'calc(2 * var(--fs-m))' : 'var(--fs-icon)'"
					>
						{{ translate('home.getting_started.title') }}
					</div>
					<div class="fl-fixed w-100 fc-400 fs-m lh-fs-xl p-0h-b">
						{{
							translate('home.getting_started.description', { username: vm.username })
						}}
					</div>
					<div class="fl-adaptable ov-h w-100 p-2-tb border-box">
						<div class="w-100 h-100 fl fl-ai-c fl-jc-c ov-h">
							<reach-youtube-player
								class="w-100 h-100 inline-player"
								[autoplay]="false"
								[inline]="true"
								[fullSize]="true"
								videoId="rF_OLxkdDb4"
							></reach-youtube-player>
						</div>
					</div>
					<div class="fl-fixed w-100 fc-400 fs-xs p-0h-t">
						<span
							[innerHTML]="
								translate('home.getting_started.footer', {
									mailLink: 'mailto:chris@rea.ch',
									pageLink:
										'https://chat.rea.ch/widget/711e84b0-dfb7-4585-b5eb-afeb96e6542f',
								})
							"
						></span>
					</div>
				</div>
				<div
					ngProjectAs="[footer]"
					class="w-100 fl fl-ai-c p-2-t"
					[class.fl-jc-fe]="isDesktop"
					[class.fl-jc-c]="!isDesktop"
				>
					<button uiNewButtonFilled (click)="baseModal?.close()">
						{{ translate('home.getting_started.start') }}
					</button>
				</div>
			</base-modal>
		}
	</ng-container>
</ng-container>
